import React from 'react';
import PropTypes from 'prop-types';

import './scss/activityLogRow.scss';

const ActivityLogRow = ({ isNewSession, stamp, text }) => (
  <tr className={ `activity-log-row ${isNewSession ? 'header-row' : ''}` }>
    <td className="stamp">{ isNewSession ? `${stamp.toLocaleDateString()} ${stamp.toLocaleTimeString()}` : '' }</td>
    <td className="text" dangerouslySetInnerHTML={ { __html: text } } />
  </tr>
);

ActivityLogRow.propTypes = {
  isNewSession: PropTypes.bool.isRequired,
  stamp: PropTypes.any.isRequired,
  text: PropTypes.string.isRequired,
};

export default ActivityLogRow;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/components/ActivityLogRow.js